<template>
    <div id="Cart" :class="{active: getShowCart, locked: getCheckoutStep > 1}">
        <div class="head">
            <button class="btn btn-sqr" @click="toggleShowCart"><i class="fal fa-times"></i></button>
        </div>
        <div class="hidden-scroll">
            <div class="loading-overlay" v-if="getLoadingOrder"></div>
            <div class="body hidden-scroll" v-if="getItems.length">
                <p class="heading">Shopping Cart</p>
                <hr>
                <div class="product" v-for="(item, index) in getItems" :key="'wine' + index" :style="'--animation-order:' + index">
                    <div class="row">
                        <div class="image" v-if="item.Product.Image && item.Product.Image.ID">
                            <img :src="item.Product.Image.URL"/>
                        </div>
                        <div class="quantity vertical-middle" v-if="getCheckoutStep > 1">
                            <div>
                                <p>{{ item.Quantity }}x</p>
                            </div>
                        </div>
                        <div class="quantity vertical-middle" v-else>
                            <div>
                                <v-select name="Quantity"
                                          :options="getQuantityOptions(item)"
                                          :clearable="false"
                                          :appendToBody="true"
                                          v-model="item.Quantity"
                                          @input="handleChange(item)">
                                </v-select>
                            </div>
                        </div>
                        <div class="name vertical-middle">
                            <div>
                                <p v-if="item.Variation">{{ item.Variation.Title }}</p>
                                <p v-else>{{ item.Product.Title }}</p>
                            </div>
                        </div>
                        <div class="price vertical-middle">
                            <div>
                                <p>${{ (item.UnitPrice * item.Quantity).toFixed(2) }}</p>
                                <p class="sub">ea ${{ item.UnitPrice.toFixed(2) }}</p>
                            </div>
                        </div>
                        <div class="bin vertical-middle">
                            <div>
                                <i class="fal fa-trash-alt" @click="productRemoveTracking(item)"></i>
                            </div>
                        </div>
                    </div>
                    <hr v-if="index != getItems.length - 1">
                </div>
            </div>
            <div class="body" v-else>
                <p>Your cart is empty</p>
            </div>
            <div class="footer" v-if="getItems.length">
                <hr>
                <div class="coupon">
                    <i class="fal fa-tag"></i>
                    <input name="PromoCode" type="text" v-model="couponCode" placeholder="Enter your promo code">
                    <button class="btn btn-light-small" @click="applyCoupon(couponCode)">Apply</button>
                </div>
                <hr>
                <table>
                    <tr>
                        <td>SubTotal</td>
                        <td>${{ getSubtotal.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="getDiscount > 0">
                        <td>Discount (Promo code)</td>
                        <td>-${{ getDiscount.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="getClubDiscount > 0">
                        <td>Discount (Membership)</td>
                        <td>-${{ getClubDiscount.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="getShipping > 0">
                        <td>Shipping</td>
                        <td>${{ getShipping.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="getDonation > 0" class="donation">
                        <td>Donation</td>
                        <td>${{ getDonation.toFixed(2) }} <i class="fas fa-minus-circle" @click="clearDonation"></i></td>
                    </tr>
                </table>
                <hr>
                <table>
                    <tr>
                        <td class="large">Total</td>
                        <td class="large">{{ itemCurrency }} ${{ getTotal.toFixed(2) }}</td>
                    </tr>
                    <tr>
                        <td class="sub">Includes tax of</td>
                        <td class="sub">${{ getTax.toFixed(2) }}</td>
                    </tr>
                </table>
                <button v-if="getCheckoutStep === 1" class="btn btn-dark shadow-light"
                        @click="setCheckoutStep(getMember.ID ? 3 : 2),checkoutTracking()">Go to Checkout
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "Cart",
    data() {
        return {
            quantityOptions: [],
            couponCode: null
        }
    },
    computed: {
        ...mapGetters(['getShowCart', 'getCheckoutStep', 'getItems', 'getMember', 'getSubtotal', 'getDiscount', 'getClubDiscount', 'getShipping', 'getTotal', 'getTax', 'getDonation', 'getLoadingOrder']),
        itemCurrency() {
            let items = this.getItems;
            if (items[0] && items[0].Product) {
                return items[0].Product.Currency;
            }
        }
    },
    methods: {
        ...mapActions(['toggleShowCheckout', 'setCheckoutStep', 'toggleShowCart', 'updateOrder', 'removeItem', 'applyCoupon', 'clearDonation']),
        handleChange(item) {
            let quantity = item.Quantity,
                link = item.Product.SetQuantityLink + '&quantity=' + quantity;
            this.updateOrder(link);
        },
        productRemoveTracking(item) {
            let product = item.Product;
            if (this.$gtm.enabled()) {
                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'event': 'remove_from_cart',
                    'ecommerce': {
                        'items': [{
                            'item_id': product.ID,
                            'item_name': product.Title,
                            'price': product.LocalisedPrice,
                            'item_category': product.ProductType,
                            'quantity': item.Quantity
                        }]
                    }
                });
            }

            this.removeItem(item.RemoveLink)
        },
        getQuantityOptions(item) {
            let product = item.Product;
            let quantityLength = 60;

            if(product.MaxOrderQuantity && product.MaxOrderQuantity > 0) {
                quantityLength = product.MaxOrderQuantity;
            }

            return Array.from(Array(quantityLength).keys(), n => n + 1);
        },
        checkoutTracking() {
            let member = this.getMember,
                memberEmail = (member && member.Email) ? 'Logged' : 'Guest';
            if (this.$gtm.enabled()) {
                let itemsList = []

                this.getItems.forEach((item) => {
                    let product = item.Product;

                    itemsList.push({
                        'item_id': product.ID,
                        'item_name': product.Title,
                        'price': product.LocalisedPrice,
                        'item_category': product.ProductType,
                        'quantity': item.Quantity
                    })
                })

                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'event': 'begin_checkout',
                    'ecommerce': {
                        'items': itemsList
                    }
                });
            }
        }
    }
}
</script>
